import { render, staticRenderFns } from "./Solucoes.vue?vue&type=template&id=73a16033&scoped=true&"
import script from "./Solucoes.vue?vue&type=script&lang=js&"
export * from "./Solucoes.vue?vue&type=script&lang=js&"
import style0 from "./Solucoes.vue?vue&type=style&index=0&id=73a16033&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a16033",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListGroup } from 'vuetify/lib/components/VList';
import { VListTile } from 'vuetify/lib/components/VList';
import { VListTileAvatar } from 'vuetify/lib/components/VList';
import { VListTileContent } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VCardText,VFlex,VLayout,VList,VListGroup,VListTile,VListTileAvatar,VListTileContent})
